<template>
  <div class="about-your-children-form-list">
    <form
      @submit.prevent
      v-for="(child, index) in children"
      :key="index"
      class="form">
      <div class="row">
        <div class="col-xs-6">
          <div class="form__group">
            <input
              v-validate.disable="'required|alpha'"
              :value="child.firstName"
              @input="updateChildFirstName({index, $event})"
              type="text"
              :id="'childFirstName-' + index"
              class="form__input"
              name="childFirstName"
              placeholder="First Name">
            <label
              class="form__label"
              :for="'childFirstName-' + index">First Name <span class="form__error">{{ errors.first('childFirstName') }}</span></label>
          </div>
        </div>
        <div class="col-xs-6">
          <div class="form__group">
            <input
              v-validate.disable="'required|alpha'"
              :value="child.lastName"
              @input="updateChildLastName({index, $event})"
              type="text"
              :id="'childLastName-' + index"
              class="form__input"
              name="childLastName"
              placeholder="Last Name">
            <label
              class="form__label"
              :for="'childLastName-' + index">Last Name <span class="form__error">{{ errors.first('childLastName') }}</span></label>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-9 col-sm-6">
          <div class="form__group">
            <input
              v-validate.disable="'required|alpha'"
              :value="child.currentSchool"
              @input="updateChildCurrentSchool({index, $event})"
              type="text"
              :id="'childCurrentSchool-' + index"
              name="childCurrentSchool"
              class="form__input"
              placeholder="Current School">
            <label
              :for="'childCurrentSchool-' + index"
              class="form__label">Current School <span class="form__error">{{ errors.first('childCurrentSchool') }}</span></label>
          </div>
        </div>
        <div class="col-xs-3 col-sm-6">
          <button
            v-if="index == children.length - 1"
            @click="addChild"
            class="btn">+ <span class="mobile-hide">Add Child</span></button>
          <button
            v-else
            class="btn"
            @click="removeChild(index)">- <span class="mobile-hide">Remove Child</span></button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'AboutYourChildForm',
  computed: {
    ...mapGetters([
      'children',
    ]),
  },
  methods: {
    ...mapActions([
      'addChild',
      'removeChild',
      'updateChildFirstName',
      'updateChildLastName',
      'updateChildCurrentSchool',
    ]),
  },
};
</script>

<style lang="scss">
  .mobile-hide {
    display: none;
  }

  button.btn {
    font-size: 3rem;
    padding: 0 1.25rem;
  }

  @media (min-width:768px){
    button.btn {
      font-size: 1rem;
      padding-top: 1.125rem;
      padding-bottom: 1.125rem;
    }
    .mobile-hide {
      display: initial;
    }
  }
</style>
